'use client'

import { useState, useEffect } from 'react'
import { ChevronUpIcon } from '@heroicons/react/24/outline'

export function BackToTop() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }

        window.addEventListener('scroll', toggleVisibility)
        return () => window.removeEventListener('scroll', toggleVisibility)
    }, [])

    const scrollToTop = () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        window.scrollTo({
            top: 0,
            behavior: reduceMotion ? 'auto' : 'smooth'
        })
    }

    if (!isVisible) return null

    return (
        <button
            onClick={scrollToTop}
            data-bottom-floating-control
            className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] right-4 z-50 hidden touch-manipulation flex-col items-center rounded-lg bg-white/90 px-2 py-1 text-water-muted opacity-80 shadow-sm transition-[bottom,color,opacity] duration-200 hover:text-water-ink hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-water-blue focus-visible:ring-offset-2 sm:flex md:hidden"
            aria-label="Back to top"
        >
            <ChevronUpIcon className="h-5 w-5" aria-hidden="true" />
            <span className="text-xs font-medium">Back to Top</span>
        </button>
    )
}
